import axios from 'axios';
const API_URL = process.env.REACT_APP_API_ENDPOINT;

export const get_Users = async () => {
    const res = await axios.post(`${API_URL}auth/get_all_user`);
    return res.data;
};
